<form [formGroup]="searchForm" class="autocomplete-container">
    <div class="position-relative">
        <input type="text" [placeholder]="placeholder" formControlName="search" class="form-control" autocomplete="off"
            (focus)="onFocus()" (blur)="onBlur()" />

        <div *ngIf="spinnerSearch" class="native-spinner small-spinner">
            Cargando...
        </div>
    </div>

    <div *ngIf="data.length > 0 && showDropdown" class="autocomplete-dropdown">
        <ul>
           

            <li *ngFor="let item of data" class="autocomplete-item" (mousedown)="onItemPointerDown($event, item)"
                (touchstart)="onItemPointerDown($event, item)">
                <div class="item-name">{{ item[displayKey] }}</div>
                <div class="item-email">{{ item[secondaryDisplayKey] }}</div>
            </li>
        </ul>
    </div>

</form>